<template>
	<div>
		<div class="mt-3">
			<div class="d-flex flex-wrap" v-if="false">
				<v-col cols="12" class="px-0">
					<div class="d-flex justify-end">
						<v-btn depressed color="grey lighten-1" class="mr-2 white--text rounded-xl text-capitalize" @click="reset">Reset</v-btn>
						<v-btn depressed color="primary" class="white--text rounded-xl text-capitalize" @click="showModalCari">
							<div class="d-flex">
								<v-icon small class="d-block d-sm-none">mdi-magnify</v-icon>
								<div class="d-none d-sm-block">Cari</div>
							</div>
						</v-btn>
					</div>
				</v-col>
			</div>
			<div class="d-flex flex-wrap mr-n3">
				<template v-if="loading">
					<v-col cols="6" sm="4" md="3" lg="3" xl="2" class="pl-0 pb-0 col-md-20" v-for="i in 5" :key="i">
						<v-card class="pa-3 elevation-0 rounded-xl hover-shadow h-100 w-100 custom-skeleton">
							<v-skeleton-loader width="100%" height="140px" type="image" class="rounded-xl"></v-skeleton-loader>
							<v-skeleton-loader width="50%" type="text" class="mt-5"></v-skeleton-loader>
							<v-skeleton-loader width="100%" type="text" class="mt-2"></v-skeleton-loader>
							<v-skeleton-loader width="50%" type="text" class="mt-2"></v-skeleton-loader>
							<v-skeleton-loader width="100%" type="heading" class="mt-3 rounded-xl"></v-skeleton-loader>
						</v-card>
					</v-col>
				</template>

				<template v-else>
					<v-col cols="12" sm="12" md="6" lg="3" xl="3" class="pl-0 pb-0" v-for="paket in paketlist" :key="paket.paket_id">
						<v-card class="pa-3 elevation-0 rounded-xl hover-shadow h-100">
							<div class="d-flex flex-column">
								<div class="rounded-xl overflow-hidden col-12 col-sm-12 col-md-12">
									<img style="width: 100%; display: block; margin: 0 auto;" :src="getPackageImg(paket.packet_image, paket.packet_id)" />
								</div>
								<div class="py-2 col-12 col-sm-12 col-md-12">
									<v-tooltip bottom>
										<template v-slot:activator="{ on, attrs }">
											<div class="font-size-14 product-name primary--text" v-bind="attrs" v-on="on">{{ paket.packet_name }}</div>
										</template>
										<span class="font-weight-bold">{{ paket.packet_name }}</span>
									</v-tooltip>
									<div class="w-100 pt-0 mt-4 font-size-10 cl-grey d-flex flex-column flex-sm-column flex-md-row justify-space-between">
										<span>Harga Paket</span>
										<span class="font-weight-bold">{{ paket.packet_value | toRupiah }} / Paket</span>
									</div>
									<div class="w-100 pt-1 mb-5 font-size-10 cl-grey d-flex flex-column flex-sm-column flex-md-row justify-space-between">
										<span>Min. Order Paket</span>
										<span class="font-weight-bold">{{ paket.packet_min_order }} Paket</span>
									</div>
								</div>
								<div class="col-12 col-sm-12 col-md-12 d-flex justify-center">
									<v-btn depressed color="primary" class="mt-3 mx-auto rounded-xl font-weight-bold text-capitalize" @click="nextStep(paket)">Pilih Paket</v-btn>
								</div>
							</div>
						</v-card>
					</v-col>
				</template>
			</div>
			<!-- <div class="mt-3" v-if="paketlist.length == 0 && !loading">
				<v-row>
					<v-col cols="12" sm="12" md="12">
						<v-card class="py-3 elevation-0 hover-shadow rounded-xl">
							<NoData></NoData>
							<div class="px-3 pt-3 text-center secondary--text">Tidak ada data paket stockist yang dapat ditampilkan</div>
						</v-card>
					</v-col>
				</v-row>
			</div> -->
		</div>
	</div>
</template>

<script>
// import { mapActions, mapState } from 'vuex'

export default {
	components: {
	},
	props: {
		paketlist: Array
	},
	data() {
		return {
			loading: false,
			btnLoading: false,
			page: 1,
			limit: '12'
		}
	},
	computed: {
	},
	methods: {
    nextStep(paket) {
      this.$emit('action', paket)
    },

		getPackageImg(paket, packet_id) {
			let imgs = ''
			if (paket) {
				imgs = paket
			} else {
				imgs = (packet_id == '1' || packet_id == '3') ? require('/public/assets/icon/stockist.png') : require('/public/assets/icon/master-stockist.png')
			}

			return imgs
		}
	},
	created() {
	},
};
</script>

<style scoped>
	.w-100 {
		width: 100%!important;
	}
</style>